<template>
  <div>
    <TopBar title="Evaluation" :cart="false"/>
    <div class="page-content">
      <div class="container">
        <div class="col-12">
          <h5 class="mb-1">Questionnaire</h5>
          <ul class="dz-timeline timeline-number">

            <NpsRow v-for="(question,index) in questions" :formData="form[index]" :key="question.id" :question="question" :index="index"/>
            <button style="width: 100%;" @click.prevent="submitNps" class="mb-10 btn btn-primary text-white" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ $t('submit') }}
            </button>
          </ul>
          <br> <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import {useStore} from "vuex";
import NpsRow from "@/components/npsRow";
import {useRouter} from "vue-router";

const store = useStore()
const loading = ref(false)
const form = ref([])
const router = useRouter();

onMounted(() => {
  store.dispatch('nps/loadQuestions')
})

const questions = computed(() => store.getters['nps/questions'])
watch(() => questions.value, () => {
  if(questions.value.length > 0){
    setInitialFormValue()
  }
})

function setInitialFormValue(){
  let data = []
  questions.value.map(question => {
    data.push({
      question_id: question.id,
      note: ''
    })
  })
  form.value = data
}

function submitNps(){
  loading.value = true
  store.dispatch('nps/setQuestionsResponses',{responses: form.value})
      .then(() =>{
        router.push({name:'home-page'})
      })
      .finally(() => {
        loading.value = false
      })
}
</script>

<style scoped>
.line-num{

}
.dz-timeline.timeline-number .timeline-item .line-content-box{
  box-shadow: 0 0 0 0 transparent;
}

.dz-timeline.timeline-number .timeline-item .line-num{
  box-shadow: 0 0 0 0 transparent;
}

.input-radius textarea.form-control{
  border-radius: 10px;
}

</style>